export const doonationTheme = {
  name: 'doonation-theme',
  tokens: {
    colors: {
      font: {
        primary: {value: '#707070'}
      },
      primary: {
        10: { value: "hsl(181, 31%, 67%)" },
        20: { value: "hsl(181, 31%, 60%)" },
        40: { value: "hsl(181, 35%, 46%)" },
        60: { value: "hsl(181, 62%, 33%)" },
        80: { value: "hsl(181, 61%, 26%)" },
        90: { value: "hsl(181, 62%, 20%)" },
        100: { value: "hsl(180, 62%, 16%)" }
      }

    },
    components: {
      heading: {
        color: {value: '{colors.primary.60}'},
      },
      card: {
        outlined: {
          borderRadius: {value: '{radii.large}'},
          borderColor: {value: '{colors.border.primary}'},
          borderWidth: '{borderWidths.small}'
        },
      },
    },
  },
};
